import styled from 'styled-components';

import { SearchableSelectVariant } from './searchable-select.types';

export const SelectWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const SelectButton = styled.div<{ open: boolean; variant: SearchableSelectVariant; hasValue: boolean }>`
	width: 100%;
	background-color: ${({ variant, theme: { input } }) => input[variant].background};
	border: 1px solid
		${({ open, variant, theme: { input } }) => (open ? input[variant].focus.border : input[variant].border)};
	border-radius: ${({ variant, theme: { input } }) => input[variant].radius};
	color: ${({ open, hasValue, variant, theme: { input } }) =>
		open ? input[variant].focus.color : hasValue ? input[variant].filled?.color : input[variant].fontColor};
	padding: 8px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	[data-searchable-select-input] {
		background: transparent;
		border: none;
		color: inherit;
		font-size: 15px;
		outline: none;
		padding: 0px 8px;
		width: 100%;
	}

	[data-searchable-select-input]::placeholder {
		color: ${({ variant, theme: { input } }) => input[variant].placeholderColor};
	}
`;

export const IconWrapper = styled.div<{ open: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	transition: transform 0.2s ease;
	transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
	cursor: pointer;
`;

export const DropdownList = styled.ul<{ variant: SearchableSelectVariant }>`
	position: absolute;
	margin-top: 8px;
	width: 100%;
	max-height: min(300px, 40vh);
	overflow-y: auto;
	background: ${({ theme: { option } }) => option.background};
	border: ${({ theme: { option } }) => option.border};
	border-radius: ${({ variant, theme: { input } }) => input[variant].radius};
	box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
	z-index: ${({
		theme: {
			zIndex: { menu },
		},
	}) => menu};

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme: { option } }) => option.hover};
		border-radius: 4px;
	}
`;

export const OptionItem = styled.li<{ isActive: boolean; isSelected: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	padding: 8px 12px 8px 36px;
	cursor: pointer;
	background: ${({ isActive, theme: { option } }) => (isActive ? option.hover : option.background)};
	color: ${({ isSelected, theme: { option } }) => (isSelected ? option.selectedColor : option.color)};
	transition: background-color 0.15s ease;

	&:hover {
		background-color: ${({ theme: { option } }) => option.hover};
	}
`;

export const EmptyOption = styled.li`
	padding: 12px;
	color: ${({ theme: { option } }) => option.color};
	font-size: 15px;
	text-align: center;
`;

export const OptionText = styled.span<{ isSelected: boolean }>`
	display: block;
	font-size: 15px;
	font-weight: ${({ isSelected }) => (isSelected ? 500 : 400)};
	color: inherit;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const CheckIconWrapper = styled.span`
	position: absolute;
	left: 12px;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
`;
